export default __webpack_public_path__ + "static/media/chantilly4.409247cb.jpg";